export function hasErrorCode(apolloError, code) {
  return apolloError.graphQLErrors?.some(
    ({ extensions }) => extensions.code === code || extensions.response?.body?.errors?.some(err => err?.code === code),
  )
}

// Same two shapes as hasErrorCode: direct GraphQL extensions, or an error wrapped by a microservice response
export function getErrorExtensions(apolloError, code) {
  for (const { extensions } of apolloError.graphQLErrors ?? []) {
    if (extensions?.code === code) return extensions
    const nestedError = extensions?.response?.body?.errors?.find(error => error?.code === code)
    if (nestedError) return nestedError
  }
  return undefined
}

export function hasErrorNetworkCode(apolloError, code) {
  return apolloError.networkError?.data?.code === code
}

export const ERROR_CODE = {
  DISPLAY_CONTENT_TAGS_NOT_FOUND: 'DISPLAY_CONTENT_TAGS_NOT_FOUND',
  TAGS_NOT_FOUND: 'TAGS_NOT_FOUND',
  PRODUCT_NOT_FOUND: 'PRODUCT_NOT_FOUND',
  DISPLAY_INVALID_TYPE: 'DISPLAY_INVALID_TYPE',
  CONTRACT_INVALID_TYPE: 'CONTRACT_INVALID_TYPE',
  CONTRACT_INVALID_STATUS: 'CONTRACT_INVALID_STATUS',
  USER_ORGANIZATION_NOT_FOUND: 'USER_ORGANIZATION_NOT_FOUND',
  USER_INVALID_STATUS: 'USER_INVALID_STATUS',
  USER_DISABLED: 'USER_DISABLED',
  ORGANIZATION_TRIAL_ENDED: 'ORGANIZATION_TRIAL_ENDED',
  GLOBAL_ROLE_CANNOT_BE_IN_ORGANIZATION: 'GLOBAL_ROLE_CANNOT_BE_IN_ORGANIZATION',
  USER_ALREADY_IN_ORGANIZATION: 'USER_ALREADY_IN_ORGANIZATION',
  ALREADY_JOBBER_IN_OTHER_ORGANIZATION: 'ALREADY_JOBBER_IN_OTHER_ORGANIZATION',
  ORGNIZATION_INVALID_OWNER: 'ORGNIZATION_INVALID_OWNER',
  CURRENT_LABEL_NOT_FOUND: 'CURRENT_LABEL_NOT_FOUND',
  PAGING_MODEL_NOT_FOUND: 'PAGING_MODEL_NOT_FOUND',
  PERMISSION_ERROR: 'PERMISSION_ERROR',
  ACTION_PERMISSION_ERROR: 'ACTION_PERMISSION_ERROR',
  DROP_TASK_NOT_ALLOWED: 'DROP_TASK_NOT_ALLOWED',
  CONTRACT_BETWEEN_SAME_ORGANIZATION: 'CONTRACT_BETWEEN_SAME_ORGANIZATION',
  FILTER_INCLUDED_EXCLUDE_SAME_ORGANIZATION: 'FILTER_INCLUDED_EXCLUDE_SAME_ORGANIZATION',
  CONTRACT_ALREADY_EXISTS: 'CONTRACT_ALREADY_EXISTS',
  OLD_PASSWORD_IS_NOT_CORRECT: 'OLD_PASSWORD_IS_NOT_CORRECT',
  NEW_PASSWORD_CANT_BE_THE_SAME_AS_OLD: 'NEW_PASSWORD_CANT_BE_THE_SAME_AS_OLD',
  INVALID_TOKEN: 'INVALID_TOKEN',
  ALREADY_EXISTING_CODE: 'ALREADY_EXISTING_CODE',
  ORGANIZATION_TRIAL_ENDPOINT_LIMIT: 'ORGANIZATION_TRIAL_ENDPOINT_LIMIT',
  ORGANIZATION_TRIAL_ENDPOINT_LOCKED: 'ORGANIZATION_TRIAL_ENDPOINT_LOCKED',
  ORGANIZATION_TRIAL_NOT_DONE: 'ORGANIZATION_TRIAL_NOT_DONE',
  ORGANIZATION_TRIAL_NOT_CONVERTED: 'ORGANIZATION_TRIAL_NOT_CONVERTED',
  ORGANIZATION_TRIAL_NOT_EXTENDABLE: 'ORGANIZATION_TRIAL_NOT_EXTENDABLE',
  ORGANIZATION_TRIAL_USERS_NOT_RESTORED: 'ORGANIZATION_TRIAL_USERS_NOT_RESTORED',
  ORGANIZATION_TRIAL_ADMINISTRATOR_INVALID: 'ORGANIZATION_TRIAL_ADMINISTRATOR_INVALID',
  ORGANIZATION_TRIAL_ONLY_FOR_SUPPLIER: 'ORGANIZATION_TRIAL_ONLY_FOR_SUPPLIER',
  ORGANIZATION_SUGGESTED_RETAILERS_LIMIT: 'ORGANIZATION_SUGGESTED_RETAILERS_LIMIT',
  ORDER_TRIAL_AUDIT_LIMIT: 'ORDER_TRIAL_AUDIT_LIMIT',
  NO_ORGANIZATION_AVAILABLE: 'NO_ORGANIZATION_AVAILABLE',
  EMAIL_ALREADY_EXISTS: 'EMAIL_ALREADY_EXISTS',
  ORDER_ALREADY_EXISTS: 'ORDER_ALREADY_EXISTS',
  CREATE_PROJECT_ERROR: 'CREATE_PROJECT_ERROR',
  PROJECT_NAME_ALREADY_EXISTS: 'PROJECT_NAME_ALREADY_EXISTS',
  PROJECT_PACKAGE_EXPECTATION_IN_USE: 'PROJECT_PACKAGE_EXPECTATION_IN_USE',
  ORDER_MUST_BE_STARTED_FROM_DIFFERENT_BATCH: 'ORDER_MUST_BE_STARTED_FROM_DIFFERENT_BATCH',
  STAGE_TEMPLATE_ALREADY_HAS_ACTIVE_VERSION: 'STAGE_TEMPLATE_ALREADY_HAS_ACTIVE_VERSION',
  PRODUCT_CUSTOMER_CODE_NOT_COMPLIANT: 'PRODUCT_CUSTOMER_CODE_NOT_COMPLIANT',
  GROUP_NAME_ALREADY_EXISTS: 'GROUP_NAME_ALREADY_EXISTS',
  ORDER_PROJECT_HAS_NO_PACKAGE: 'ORDER_PROJECT_HAS_NO_PACKAGE',
  ORDER_PROJECT_HAS_NO_DT_PACKAGE: 'ORDER_PROJECT_HAS_NO_DT_PACKAGE',
  GROUP_LIMIT_EXCEEDED: 'GROUP_LIMIT_EXCEEDED',
  ORDER_PROJECT_HAS_NO_CUSTOMER_PACKAGE: 'ORDER_PROJECT_HAS_NO_CUSTOMER_PACKAGE',
  PRESET_WITH_THE_SAME_SETTINGS_ALREADY_EXISTS: 'PRESET_WITH_THE_SAME_SETTINGS_ALREADY_EXISTS',
  PRESET_USED_OTHER_EXPECTATIONS: 'PRESET_USED_OTHER_EXPECTATIONS',
  NAMING_CONVENTION_LAST_ACTIVE: 'NAMING_CONVENTION_LAST_ACTIVE',
  NOT_ALL_PRESETS_CREATED: 'NOT_ALL_PRESETS_CREATED',
  GTIN_DUPLICATED_ERROR: 'GTIN_DUPLICATED_ERROR',
  PRODUCT_GTIN_NON_NUMERIC: 'PRODUCT_GTIN_NON_NUMERIC',
  PRODUCT_GTIN_WRONG_LENGTH: 'PRODUCT_GTIN_WRONG_LENGTH',
  PRODUCT_GTIN_BAD_CHECKSUM: 'PRODUCT_GTIN_BAD_CHECKSUM',
  NOT_LOGGED_IN: 'NOT_LOGGED_IN',
  PRODUCT_HAS_NO_NAME: 'PRODUCT_HAS_NO_NAME',
  PRODUCT_HAS_NO_CATEGORY: 'PRODUCT_HAS_NO_CATEGORY',
  CATEGORY_ALREADY_EXISTS: 'CATEGORY_ALREADY_EXISTS',
  CUSTOM_BRAND_ALREADY_EXISTS: 'CUSTOM_BRAND_ALREADY_EXISTS',
}
